<template>
  <div class="dev-main ">

    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
        <el-card class="box-card clearfix" style="max-height: 586px;overflow: auto">

          <p style="text-align: left">{{topicDetail.title}}</p>
          <div class="clearfix">
            <div class="fl vertical" style="margin-top: 10px;margin-right: 20px">
              <img :src="$baseUrl+'img/avatar.png'" style="width:16px"/>
              <span style="color: #999999;font-size: 12px">{{topicDetail.createUserName}}</span>
            </div>

            <el-tag class="tag" v-for="item in  subCategoryList" :key="item.id" type="info">
              {{item.subCategoryName}}
            </el-tag>
            <div class="fr" style="margin-top: 15px;color: #999999;font-size: 12px">
              <span>{{topicDetail.updateDate | formatDate}}</span>
            </div>
          </div>

          <!--<div v-html="topicDetail.content">

          </div>-->
          <div id="preview"></div>

          <div class="clearfix">
            <el-button class="sign main-bg-color fl" size="mini" @click="responseQuestions()">
              写回答
            </el-button>
          </div>
        </el-card>
        <el-card class="box-card clearfix" v-if="showRespAreaFlag">
          <el-form ref="form" :model="form" label-width="0px" :rules="rules">
            <el-form-item label="" prop="content" class="clearfix">
             <!-- <tinymce-editor
                id="editor"
                ref="editor"
                v-model="form.content"
                :height="realHeight"
                @handleImgUpload="imgUpload"
              />-->
              <VditorEditor v-model="form.content" editorId="vditor" />
            </el-form-item>
          </el-form>
          <div class="fl" style="margin: 20px 0">
           <!-- <el-checkbox v-model="anonymousFlag">匿名</el-checkbox>-->
            <el-button type="primary" @click="submitTopicDetail" class="main-bg-color" size="tiny"
                      >
              提交
            </el-button>
          </div>

        </el-card>
        <el-card class="box-card clearfix" style="text-align: left;position: relative">
          <div class="res-title"><span>{{topicResponses.length}}条回答</span></div>
          <div class="res-item vertical" v-for="o in topicResponses" :key="o.id">
            <img :src="$baseUrl+'img/avatar.png'" style="width:16px"/>
            <span class="info">{{o.createUserName}}</span>
            <span class="info">{{o.updateDate | formatDate}}</span>
            <span class="info">赞&nbsp;&nbsp;{{o.likeCnt}}</span>
            <div style="text-align: left;font-size: 14px;margin: 20px 0" v-html="o.content">

            </div>

            <div class="vertical " >
              <img class="pointer"  @click="likeResponse(o.id)" :src="$baseUrl+'img/like.png'"/>
              <span class="info">很有帮助，点赞一下</span>
            </div>
            <el-divider></el-divider>
          </div>

          <PageComponent ref="pageInfo"></PageComponent>
        </el-card>

      </el-col>
      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
        <el-card class="box-card ">
          <div class="clearfix">
            <div class="fl">
              <router-link :to="{path:'/question/add'}" style="margin-right: 20px">
                <el-button class="sign main-bg-color" size="mini">
                  <span class="submit-word">提问</span>
                </el-button>
              </router-link>
              <router-link :to="{path:'/contribute/add'}">
                <el-button class="sign main-bg-color" size="mini">
                  <span class="submit-word">投稿</span></el-button>
              </router-link>
            </div>
            <div class="fr">
              <div v-if="user && user.loginId && user.loginId != null" class="vertical">
                <img :src="$baseUrl+'img/avatar.png'" style="width:16px"/>
                <span style="font-size: 12px">{{user.loginId}}</span>
              </div>
              <router-link v-else :to="{path:'/login'}" class="vertical view-more">
                <i class="el-icon-user-solid"></i>
                <span style="font-size: 12px">去登录</span>
              </router-link>
            </div>
          </div>
        </el-card>
        <el-card class="box-card clearfix">
          <div class="qus">
            <span class="title bold">提问推荐</span>
          </div>

          <div class="bottom clearfix" v-for="item in recommendQuestionList" :key="item.id">

            <el-divider></el-divider>
            <div @click="gotoNextRouter(item)" class="qus pointer">
              <span class="title ellipsis">{{item.title}}</span>
              <el-tag class="tag" v-for="subItem in  item.subCategoryList" :key="subItem.id" type="info">
                {{subItem.subCategoryName}}
              </el-tag>
              <div class="fr" style="margin-top: 15px;color: #999999;font-size: 12px">
                <span>回答{{item.respCnt}}</span>
              </div>
            </div>

          </div>

        </el-card>
        <el-card class="box-card clearfix">
          <div class="qus">
            <span class="title bold">专栏推荐</span>
          </div>

          <div class="bottom clearfix" v-for="item in recommendContributeList" :key="item.id">

            <el-divider></el-divider>
            <div @click="gotoNextRouter(item)" class="qus">
              <span class="title ellipsis">{{item.title}}</span>
              <el-tag class="tag" v-for="subItem in  item.subCategoryList" :key="subItem.id" type="info">
                {{subItem.subCategoryName}}
              </el-tag>
              <div class="fr" style="margin-top: 15px;color: #999999;font-size: 12px">
                <span>{{item.updateDate | formatDate()}}</span>
              </div>
            </div>

          </div>

        </el-card>
        <a href="https://www.pingxingyun.com/console/#/contribute/detail?topicId=10023&categoryId=3" target="_blank">
          <el-image :src="$baseUrl+'img/activity-palyback.jpg'" style="margin-top: 10px">
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
          </el-image>
        </a>


        <el-card class="box-card clearfix">

          <div style="text-align: left;margin-bottom: 20px;margin-left: 3px">
            关注我们
          </div>
          <div class="vertical">
            <img :src="$baseUrl+'img/pxy-ewm.png'" style="width: 79px"/>
            <span style="text-align: left;font-size: 14px;margin-right:0;margin-left:10px;
            vertical-align: top;width: calc(100% - 100px);line-height: 25px">
              邮箱：support@pingxingyun.com
              <br/>QQ群：716122787
            </span>
          </div>
        </el-card>
      </el-col>
    </el-row>


  </div>
</template>

<script>
  import TinymceEditor from '@/components/editor/tinymce-editor'
  import VditorEditor from '@/components/editor/vditor'
  import PageComponent from '@/components/pageInfo/PageComponent'
  import {Message} from "element-ui";
  import Vditor from 'vditor';
  import 'vditor/dist/index.css';
  export default {
    components: {VditorEditor, TinymceEditor, PageComponent},
    data() {
      return {
        topicDetail: {},
        subCategoryList: [],
        topicResponses: [],
        userInfo: {},
        showRespAreaFlag: false,
        recommendQuestionList:[],
        recommendContributeList: [],
        form: {
          topicId: this.$route.query.topicId,
          content: '', //富文本的内容
          categoryId: this.$route.query.categoryId,
          subCategoryId: ''
        },
        rules: {
          content: [{required: true, message: '请输入内容', trigger: 'blur'}],
        },
        anonymousFlag: false

      }
    },
    computed: {
      realHeight() {
        return (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 200
      },
      user() {
        return this.$store.state.user;
      },
      routes() {
        return this.$store.state.routes
      }
    },
    created() {

    },
    methods: {
      async imgUpload(blobInfo, success, failure) {
        const formData = new FormData();
        formData.append('file', blobInfo.blob());
        try {
          this.postMultipartRequest('/util/upload/picFile', formData).then(resp => {
            if (resp && resp.status == 200) {
              var url = resp.data.result.url;
              success(url);

            }
          })

        } catch (e) {
          console.log(e);
          failure('上传失败:' + e);
        }
      },
      responseQuestions: function () {
        this.showRespAreaFlag = true;
      },
      submitTopicDetail: function () {
        var _this = this;
        var params = {};
        params.content = _this.form.content;
        params.topicId = _this.form.topicId;
        params.anonymousFlag = _this.anonymousFlag
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.postRequestJson('/tccTopic/addTopicDetail?anonymousFlag=' + _this.anonymousFlag, JSON.stringify(params)).then(resp => {
              _this.loading = false;
              if (resp && resp.status == 200) {
                var data = resp.data;
                if (data.code == 1000) {
                  _this.getTopicResponses();
                  _this.form.content = '';
                } else {
                  Message.error(data.message);
                }

              }
            });
          }
        })
      },
      topicView: function () {
        this.getRequest('/tccTopic/viewDetail', {'id': this.form.topicId}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.topicDetail = resp.data.result;
              const previewElement = document.getElementById('preview');
              Vditor.preview(previewElement, this.topicDetail.content, {
                hljs: { style: 'github' },
              });
              //获取该提问的回答内容
              this.getTopicResponses();

              var subCategoryId = this.topicDetail.subCategoryId;
              //获取标签的名称
              this.getSubCategory(subCategoryId).then(resp =>{
                this.subCategoryList = resp;
              });
              //获取当前标签下的推荐问题
              this.getRecommendContributes(subCategoryId)
              this.getRecommendQuestions(subCategoryId)
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      getTopicResponsesLength: function (topicId) {
        return this.getRequest('/tccTopic/getDetailList', {
          topicId: topicId,
          page: 1,
          pageSize: 20
        }).then(async resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              return resp.data.result.records.length;
            }
          } else {
            return 0;
          }
        })
      },
      getTopicResponses: function () {
        var params = {};
        params.topicId = this.form.topicId;
        params.page = 1;
        params.pageSize = 5;
        this.getRequest('/tccTopic/getDetailList', params).then(async resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.topicResponses = resp.data.result.records;
              this.$refs.pageInfo.outputPagenator(resp.data.result.total, resp.data.result.pageSize);
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      getSubCategory: function (subCategoryId) {
        return this.getRequest('/tccTopic/getSubCategoryList', {'subCategoryId': subCategoryId}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              return resp.data.result;
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      getRecommendQuestions: function (subCategoryId) {
        var params = {};
        if (subCategoryId != null) {
          params.subCategoryId = subCategoryId;
        }
        params.categoryId = 2;
        params.page = 1;
        params.pageSize = 3;
        this.getRequest('/tccTopic/getList', params).then(async resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.recommendQuestionList = resp.data.result.records;
              for (var i = 0; i < this.recommendQuestionList.length; i++) {
                await this.getTopicResponsesLength(this.recommendQuestionList[i].id).then(resp => {
                  var cnt = resp;
                  this.$set(this.recommendQuestionList[i], 'respCnt', cnt);
                });
                await this.getSubCategory(this.recommendQuestionList[i].subCategoryId).then(resp => {
                  this.$set(this.recommendQuestionList[i], 'subCategoryList', resp)
                });
              }
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },

      getRecommendContributes: function () {
        var params = {};
        params.categoryId = 3;
        params.page = 1;
        params.pageSize = 3;
        this.getRequest('/tccTopic/getList', params).then(async resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.recommendContributeList = resp.data.result.records;
              for (var i = 0; i < this.recommendContributeList.length; i++) {
                await this.getSubCategory(this.recommendContributeList[i].subCategoryId).then(resp => {
                  this.$set(this.recommendContributeList[i], 'subCategoryList', resp)
                });
              }
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      gotoNextRouter: function (o) {
        this.$router.push({path: '/question/detail', query: {topicId: o.id, categoryId: this.form.categoryId}});
        this.form.topicId = o.id;
        this.topicView();
      },
      likeResponse: function (id) {
        var params = {};
        params.id = id;
        this.postRequestJson('/tccTopic/like?', JSON.stringify(params)).then(resp => {
          if (resp && resp.status == 200) {
            var data = resp.data;
            if (data.code == 1000) {
              this.getTopicResponses();
            } else {
              Message.error(data.message);
            }

          }
        });
      }
    }
    ,
    mounted: function () {
      this.topicView();
      this.$emit('setActiveIndex', "6")
      this.$refs.pageInfo.initPagenator(this.getTopicResponses, null);
    }
    ,
    beforeDestroy() {

    }
  }
</script>

<style>
  #preview a {
    color: #0f7ddb !important;
  }
</style>
